/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_TeilleistungsschwaechenInputs */

const de__field_teilleistungsschwaechen = /** @type {(inputs: _Field_TeilleistungsschwaechenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teilleistungsschwächen`)
};

/**

* @param {_Field_TeilleistungsschwaechenInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_teilleistungsschwaechen = /** @type {((inputs?: _Field_TeilleistungsschwaechenInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_TeilleistungsschwaechenInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_teilleistungsschwaechen(inputs)
});